import { render, staticRenderFns } from "./OptionEditDetailsTab.vue?vue&type=template&id=233ac44a"
import script from "./OptionEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports